import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FiBox, FiFolder, FiHeart, FiList, FiPlus, FiSearch, FiTag } from 'react-icons/fi';
import { prefetchHandlers } from '../../utils/prefetchRoute';
import './VaultHubNav.css';

const VAULT_NAV = {
    vault: [
        { to: '/additems', label: 'Create Item', shortLabel: 'Create', Icon: FiPlus, prefetch: '/additems', phoneOnly: true },
        { to: '/searchcollectibles', label: 'View Collectibles', shortLabel: 'Collectibles', Icon: FiBox },
        { to: '/myitems?page=1', label: 'My Items', shortLabel: 'My Items', Icon: FiFolder },
        { to: '/myHeroCardWishList', label: 'My Wish List', shortLabel: 'Wish List', Icon: FiHeart, prefetch: '/myHeroCardWishList' },
    ],
    marketplace: [
        { to: '/marketplace', label: 'Browse Listings', shortLabel: 'Browse', Icon: FiSearch },
        { to: '/createmarketplaceitem', label: 'Sell an Item', shortLabel: 'Sell', Icon: FiTag, prefetch: '/createmarketplaceitem' },
        { to: '/mymarketplacelistings', label: 'My Listings', shortLabel: 'Listings', Icon: FiList, prefetch: '/mymarketplacelistings' },
    ],
};

// Back-compat aliases - collectibles/heroCards hubs now share The Vault nav
VAULT_NAV.collectibles = VAULT_NAV.vault;
VAULT_NAV.heroCards = VAULT_NAV.vault;

const ARIA_LABELS = {
    vault: 'THE VAULT navigation',
    collectibles: 'THE VAULT navigation',
    heroCards: 'THE VAULT navigation',
    marketplace: 'Marketplace navigation',
};

const COLLECTIBLES_BROWSE_PATHS = ['/searchcollectibles', '/searchdiecasts', '/searchherocards'];

const VaultHubNav = ({ variant = 'vault', layout = 'pills' }) => {
    const location = useLocation();
    const rawItems = VAULT_NAV[variant] || VAULT_NAV.vault;
    // Desktop sidebar already has an Add items CTA — keep Create in the phone tab bar only
    const items = layout === 'sidebar'
        ? rawItems.filter((item) => !item.phoneOnly)
        : rawItems;
    const normalizedPath = location.pathname.toLowerCase();
    const ariaLabel = ARIA_LABELS[variant] || ARIA_LABELS.vault;
    const navClassName = `msv-vault-hub-nav msv-vault-hub-nav--${layout}`;

    return (
        <nav className={navClassName} aria-label={ariaLabel}>
            {items.map(({ to, label, shortLabel, Icon, prefetch }) => {
                const linkPath = to.split('?')[0].toLowerCase();
                const isCollectiblesBrowse =
                    linkPath === '/searchcollectibles' &&
                    COLLECTIBLES_BROWSE_PATHS.includes(normalizedPath);
                const isActive = normalizedPath === linkPath
                    || isCollectiblesBrowse
                    || (linkPath === '/myitems' && ['/mycollection', '/myherocards'].includes(normalizedPath));

                return (
                    <Link
                        key={to}
                        to={to}
                        className={`msv-vault-hub-link${isActive ? ' is-active' : ''}`}
                        aria-current={isActive ? 'page' : undefined}
                        aria-label={label}
                        title={label}
                        {...(prefetch ? prefetchHandlers(prefetch) : {})}
                    >
                        {Icon && (
                            <Icon className="msv-vault-hub-icon" aria-hidden />
                        )}
                        <span className="msv-vault-hub-label">{label}</span>
                        <span className="msv-vault-hub-short-label">{shortLabel || label}</span>
                    </Link>
                );
            })}
        </nav>
    );
};

export default VaultHubNav;
